import React from "react";
import { useField } from "formik";
import { Form } from "react-bootstrap";
import SelectBox from "../SelectBox";

const FormSelectBox = ({
  name,
  onChange = null,
  onBlur = null,
  option_name = "name",
  option_value = "value",
  label,
  hint = "",
  required = false,
  className = "mb-3",
  ...rest
}) => {
  const [field, meta] = useField(name);

  const getError = () => {
    if (!meta.touched || !meta.error) return null;
    if (Array.isArray(meta.error)) return meta.error.join(", ");
    return meta.error;
  };

  const error = getError();

  return (
    <Form.Group className={className}>
      {label && (
        <Form.Label>
          {label} {required && "*"}
        </Form.Label>
      )}
      <SelectBox
        name={name}
        option_name={option_name}
        option_value={option_value}
        value={field.value}
        onChange={onChange ?? field.onChange}
        onBlur={onBlur ?? field.onBlur}
        {...rest}
      />
      {hint && <Form.Text className="text-muted">{hint}</Form.Text>}
      {error && <small className="text-danger">{error}</small>}
    </Form.Group>
  );
};

export default FormSelectBox;
